var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargingPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M11.646 5.782l7.072 7.072M10.94 13.56l-4.243 4.243M15.89 5.782l-2.122 2.122M18.718 8.61l-2.122 2.122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.354 6.49l5.656 5.656-2.828 2.829a4 4 0 11-5.657-5.657l2.829-2.828h0z",
    fill: "#666"
  })))));
}
export default SvgChargingPoint;